// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__2pAUx","error":"Tab_error__4trXy","selected":"Tab_selected__52FuJ","badge":"Tab_badge__TvFhQ"};